module.exports = __webpack_public_path__ + "article-7051a3ee/der-perfekte-schlusssatz-fuer-deine-ba285b28a5a1055a7c1e1497d57c816a.jpeg";